/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ManifestService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Manifest de l'application d'une entreprise
     * Le `manifest.json` de l'application installable, personnalise avec le nom et les icones de l'entreprise `companyKey` (manifest Lol@pp par defaut si la cle est inconnue). Public, mis en cache.
     * @param companyKey
     * @returns any
     * @throws ApiError
     */
    public manifestManifest(
        companyKey: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/manifest/{companyKey}',
            path: {
                'companyKey': companyKey,
            },
        });
    }
    /**
     * Icone de l'application d'une entreprise
     * PNG carre de `size` pixels, genere depuis l'icone configuree par l'entreprise (icone Lol@pp par defaut sinon). Mis en cache. 400 pour une taille non supportee.
     * @param companyKey
     * @param size
     * @returns any
     * @throws ApiError
     */
    public manifestIcon(
        companyKey: string,
        size: number,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/company/{companyKey}/icon/{size}',
            path: {
                'companyKey': companyKey,
                'size': size,
            },
            errors: {
                400: `An error`,
            },
        });
    }
}
